export default "__VITE_ASSET__a80844b8__"